module.exports = __webpack_public_path__ + "static/media/clock-orange.93eab567.svg";